
import { get_cookies } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/cookies.js?1733898722585';
import { get_cookie_name } from '/srv/web/wyvr/html/releases/58819/gen/client/odoscope/api/get_cookie_name.js?1733898722585';

export function get_cookie(token) {
    if (false) {
        return undefined;
    }
    const cookies = get_cookies();
    const value = cookies[get_cookie_name(token)];
    if (!value) {
        return undefined;
    }
    return value;
}
